<div class="SLV2-excrsprgrs-full-area">

    <div class="SLV2-excrsprgrs-poparea">
        <div class="SLV2-excrsprgrs-hdr">
            <button class="SLV2-popup-close-btn" (click)="goToNextTopic()">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/banner-back-arrow.svg" />
            </button>
            <span class="desk-hide">Exercise</span>
        </div>


        <!-- <ng-container *ngTemplateOutlet="SLV2Attmpcunt"></ng-container> -->

        <div class="SLV2-progress-info-box white">
            <ng-container>
                <ng-container *ngTemplateOutlet="SLV2Accuracycunt" ></ng-container>
            </ng-container>
            


            <ng-container *ngIf="exerciseResultData.percentage >= 80">
                <div class="SLV2-progress-icon-holdr sm">
                    <img src="selflearnv2-ui/assets/img/animation-champion-icon.gif" />
                </div>
                <div class="SLV2-progress-info-cntarea">
                    <h3 class="SLV2-progress-greeting-hdng">Well done!</h3>
                    <p class="SLV2-progress-text">You have cleared this exercise</p>
                    <p class="SLV2-progress-text">Go to next topic to improve your chapter progress.</p>
                    <div class="SLV2-progress-actn-area">
                        <button class="SLV2-progress-solid-btn" (click)="goToNextTopic()">{{isLastTopic ? 'Continue Learning' : 'Go To Next Topic'}}</button>
                        <button class="SLV2-progress-text-btn" (click)="viewSolutionForExercise()">View solutions</button>
                    </div>
                </div>
            </ng-container>


            <ng-container *ngIf="exerciseResultData.percentage < 80">
                <div class="SLV2-progress-icon-holdr sm">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/sad-emoji-animated.gif" />
                </div>
                <div class="SLV2-progress-info-cntarea">
                    <h3 class="SLV2-progress-greeting-hdng">Uh-uh!</h3>
                    <p class="SLV2-progress-text">Score at least 80% to clear this exercise</p>
                    <p class="SLV2-progress-text">Don’t worry. Together we will get there.</p>
                    <div class="SLV2-progress-actn-area">
                        <button class="SLV2-progress-solid-btn" (click)="reattemptNow()">Re-attempt</button>
                        <button class="SLV2-progress-text-btn"  (click)="viewSolutionForExercise()">View solutions</button>
                    </div>
                </div>
            </ng-container>

        </div>
    </div>

</div>


<ng-template #SLV2Accuracycunt>
    <div class="SLV2-accuracy-box">
        <div class="SLV2-acrcy-col">
            <h4 class="SLV2-accuracy-title">Accuracy <img src="selflearnv2-ui/assets/img/self-learn-v2/info-icon.svg" />
            </h4>
            <h3 class="SLV2-accuracy-number">  {{exerciseResultData.accuracy  ? (exerciseResultData.accuracy   | number: '1.0-0') : '0'}}%</h3>
        </div>
        <div class="SLV2-acrcy-col">
            <h4 class="SLV2-accuracy-title">Attempts</h4>
            <h3 class="SLV2-accuracy-number">{{exerciseResultData.attempt < 10 ? '0'+exerciseResultData.attempt   : exerciseResultData.attempt}}</h3>
        </div>
    </div>
</ng-template>